import { render, staticRenderFns } from "./searchList.vue?vue&type=template&id=640ec086&scoped=true"
import script from "./searchList.vue?vue&type=script&lang=js"
export * from "./searchList.vue?vue&type=script&lang=js"
import style0 from "./searchList.vue?vue&type=style&index=0&id=640ec086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ec086",
  null
  
)

export default component.exports